import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
const determineHasValue = val => val != null && val.toString().length > 0;
const Input = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    defaultValue,
    value,
    onChange = noop,
    ...props
  } = _ref;
  const isValueControlledRef = React.useRef(value !== undefined);
  let hasValue;
  let handleChange;
  if (isValueControlledRef.current) {
    hasValue = determineHasValue(value);
    handleChange = onChange;
  } else {
    /* eslint-disable react-hooks/rules-of-hooks */
    const [hasValueState, setHasValue] = React.useState(determineHasValue(defaultValue));
    handleChange = evt => {
      const {
        value: newValue
      } = evt.currentTarget;
      setHasValue(determineHasValue(newValue));
      onChange(evt);
    };
    hasValue = hasValueState;
  }
  return /*#__PURE__*/React.createElement("input", _extends({
    ref: ref,
    onChange: handleChange,
    value: value,
    defaultValue: defaultValue,
    "data-has-value": hasValue ? '' : undefined
  }, props));
});
process.env.NODE_ENV !== "production" ? Input.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
} : void 0;
export default Input;